export default "__VITE_ASSET__Bw9TwWVp__"